export const mockSendHistory = [
    {
        id: 1,
        email: "Samson.csw@gtdf.com",
        status: "Sent",
        sentAt: "2025-04-07T10:30:00Z",
    },
    {
        id: 2,
        email: "steven2894@hotmail.com",
        status: "Completed",
        sentAt: "2025-04-06T14:45:00Z",
    },
    {
        id: 3,
        email: "S.P.Bellow@Stewards.com",
        status: "Opened",
        sentAt: "2025-04-05T09:15:00Z",
    },
];
